import { isSupportedLang } from '@utils/langUtils';
import { useSearchParams } from 'react-router';
import type { LocaleKey } from 'src/locales';
import { useAppSelector } from 'universal-scripts';

export default function useCurrentLang(): LocaleKey {
	const intlLang = useAppSelector((state) => state.intl.lang);
	const [searchParams] = useSearchParams();
	const urlLang = searchParams.get('lang');
	if (isSupportedLang(urlLang)) {
		return urlLang.toLowerCase() as LocaleKey;
	}
	if (isSupportedLang(intlLang)) {
		return intlLang;
	}
	return 'es';
}
